import { FaDoorClosed } from 'react-icons/fa';
import { images } from '../constants';

const pricing = [
  {
    id: 1,
    image: images.plan1,
    icon: <FaDoorClosed />, // Door icon
    title: 'Basic Package',
    price: 49.00,
    features: [
      'Door Repair and Replacement',
      'Lock Installation',
      'Weatherstripping',
      'Energy-Efficient Solutions',
      'Priority Service',
    ],
  },
  {
    id: 2,
    image: images.plan2,
    icon: <FaDoorClosed />, // Door icon
    title: 'Standard Package',
    price: 99.00,
    features: [
      'Door Repair and Replacement',
      'Lock Installation',
      'Weatherstripping',
      'Energy-Efficient Solutions',
      'Priority Service',
    ],
  },
  {
    id: 3,
    image: images.plan3,
    icon: <FaDoorClosed />, // Door icon
    title: 'Premium Package',
    price: 199.00,
    features: [
      'Door Repair and Replacement',
      'Lock Installation',
      'Weatherstripping',
      'Energy-Efficient Solutions',
      'Priority Service',
    ],
  },
];

export default pricing;